import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import { InspectOverlayHost } from '../../shared/InspectOverlayHost'

const opacityAnimation = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`

export const FullScreenContainer = styled(InspectOverlayHost)({
    position: 'fixed',
    width: '100%',
    height: '100%',
    zIndex: 5,
    top: 0,
    justifyContent: 'flex-end',
    flexDirection: 'column',
    animation: `${opacityAnimation} 0.1s ease-in`,
    pointerEvents: 'all',
    backgroundColor: 'black',
})
